import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=780bd332&scoped=true&"
import script from "./AppList.vue?vue&type=script&lang=js&"
export * from "./AppList.vue?vue&type=script&lang=js&"
import style0 from "./AppList.vue?vue&type=style&index=0&id=780bd332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780bd332",
  null
  
)

export default component.exports